import { useObserver } from "mobx-react";
import {
  MdOutlineAddCircleOutline,
} from "react-icons/md";
import { useStores } from "../../store";

export default function InfoCards(props) {
  const { PopupStore } = useStores();
  return useObserver(() => (
    <div className="flex flex-row md:items-start md:h-fit lg:h-fit h-[14vh] z-10 lg:items-start items-center bg-black text-white p-6 rounded-xl gap-3 w-[94%] mx-auto md:mb-0 md:w-full">
      <div className="flex flex-col items-center justify-center h-fit w-[25%]">
        <p className="bg-primary2 p-5 md:my-0 lg:my-0 h-fit my-auto rounded-full">
          {props.icon}
        </p>
      </div>
      <div className="flex flex-col gap-0.5 w-full">
        <span className="flex flex-row justify-between items-center w-[90%] ">
          <h1 className="text-lg font-semibold text-[#F1EAE0]">{props.name}</h1>
          {props.name === "Credits" ? (
            <button
              className="bg-primary flex gap-1 -mr-10 items-center text-white rounded-md px-2 py-1 text-xs "
              onClick={() => {
                PopupStore.setGetMoreCredits(true);
              }}
            >
              <MdOutlineAddCircleOutline /> Get Credits
            </button>
          ) : (
            <></>
          )}
        </span>
        {props.name === "Credits" ? (
          <p className=" text-sm font-semibold">
            Available <span className="text-primary"> : {props.count}</span>
          </p>
        ) : (
          <p className="text-sm font-semibold">
            Total {props.name}{" "}
            <span className="text-primary"> : {props.count}</span>
          </p>
        )}
        {props.name === "Assessments" && (
          <div className="flex md:gap-6 lg:gap-6 gap-1 md:flex-row lg:flex-row flex-col text-xs mt-1 text-white">
            <div className="flex flex-row justify-items-start items-center gap-6 text-xs whitespace-nowrap">
              <span>MCQ's : {props.mcq}</span>
              <span>Technical : {props.tech}</span>
            </div>
            <div className="flex flex-row justify-items-start items-center gap-6 text-xs whitespace-nowrap">
              <span>HR Interview : {props.hr}</span>
            </div>
          </div>
        )}
        {props.name === "Candidates" && (
          <div className="flex md:gap-6 lg:gap-6 gap-1 md:flex-row lg:flex-row flex-col text-xs mt-1 text-white">
            <div className="flex flex-row justify-items-start items-center gap-6 text-xs whitespace-nowrap">
              <span>Short Listed : {props.shortlisted}</span>
              <span>Hired : {props.hired}</span>
            </div>
            <div className="flex flex-row justify-items-start items-center gap-6 text-xs whitespace-nowrap">
              <span>Rejected : {props.rejected}</span>
            </div>
          </div>
        )}
        {props.name === "Credits" && (
          <div className="flex flex-row justify-items-start items-center gap-6 text-xs mt-1 text-white whitespace-normal">
            <span>Total : {props.Total}</span>
            <span>Used : {props.used}</span>
          </div>
        )}
      </div>
    </div>
  ));
}
